/* GlamShines brand motion: reveals, header state, rails, gentle parallax. Respects reduced motion. */
(function () {
  'use strict';
  var d = document, root = d.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) root.classList.add('gs-noanim');
  // V5: scroll-linked motion (parallax, depth) only on large screens with a fine pointer. On touch devices the
  // browser scrolls on the compositor while JS runs on the main thread, so scroll-linked transforms lag and the
  // images appear to drift or jump; there we keep everything still.
  var richMotion = !reduce && window.matchMedia('(pointer: fine) and (min-width: 1100px)').matches;
  if (!richMotion) root.classList.add('gs-calm');

  // reveal on scroll
  var els = d.querySelectorAll('[data-gs-reveal]');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  } else { els.forEach(function (el) { el.classList.add('is-in'); }); }

  // header state
  var hdrEl = d.querySelector('.section-header'), hdrTop = hdrEl ? Math.max(0, hdrEl.getBoundingClientRect().top + window.scrollY) : 24;
  var ticking = false;
  function onScroll() {
    root.classList.toggle('gs-scrolled', window.scrollY > hdrTop);
    if (richMotion) parallax();
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  // parallax (small, transform-only)
  var px = [].slice.call(d.querySelectorAll('[data-gs-parallax]'));
  function parallax() {
    var vh = window.innerHeight;
    px.forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
      var k = parseFloat(el.getAttribute('data-gs-parallax')) || 0.05;
      var lim = r.height * 0.045, off = Math.max(-lim, Math.min(lim, (r.top + r.height / 2 - vh / 2) * k)); // never expose the frame edge
      var img = el.querySelector('img'); if (img) img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.1)';
    });
  }
  onScroll();

  // product rails: buttons, drag, progress
  d.querySelectorAll('[data-gs-rail]').forEach(function (sec) {
    var track = sec.querySelector('[data-gs-track]'), bar = sec.querySelector('[data-gs-progress]');
    if (!track) return;
    function step() { var it = track.querySelector('.gs-rail__item'); return it ? it.getBoundingClientRect().width + 20 : 300; }
    var prev = sec.querySelector('[data-gs-prev]'), next = sec.querySelector('[data-gs-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    function prog() {
      if (!bar) return; var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / track.scrollWidth; var p = max > 0 ? track.scrollLeft / max : 1;
      bar.style.width = Math.max(vis * 100, 8) + '%'; bar.style.marginLeft = ((1 - vis) * p * 100) + '%';
    }
    track.addEventListener('scroll', prog, { passive: true }); window.addEventListener('resize', prog); prog();
    // mouse drag (pointer: fine only)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });
  // chapters: hover/focus index swaps the cover on the stage
  d.querySelectorAll('[data-gs-chapters]').forEach(function (sec) {
    var links = sec.querySelectorAll('[data-gs-chapter]'), covers = sec.querySelectorAll('[data-gs-cover]');
    function show(i) {
      links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-gs-chapter') === String(i)); });
      covers.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-gs-cover') === String(i)); });
    }
    links.forEach(function (l) {
      var i = l.getAttribute('data-gs-chapter');
      l.addEventListener('mouseenter', function () { show(i); });
      l.addEventListener('focus', function () { show(i); });
    });
  });

  // hallmark + signature reveals, reels play only while visible
  if ('IntersectionObserver' in window) {
    var once = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); once.unobserve(e.target); } });
    }, { threshold: 0.35 });
    d.querySelectorAll('[data-gs-hallmark], .gs-sigdraw, [data-gs-gift], [data-gs-about-draw], .gs-foot__stage').forEach(function (el) { if (reduce) el.classList.add('is-in'); else once.observe(el); });
    var vids = d.querySelectorAll('.gs-reel video');
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target, fig = v.closest('.gs-reel');
        if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); fig && fig.classList.add('is-playing'); }
        else { v.pause(); fig && fig.classList.remove('is-playing'); }
      });
    }, { threshold: 0.6 });
    vids.forEach(function (v) { v.muted = true; vio.observe(v); v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); }); });
  } else {
    d.querySelectorAll('[data-gs-hallmark], .gs-sigdraw, [data-gs-gift], [data-gs-about-draw], .gs-foot__stage').forEach(function (el) { el.classList.add('is-in'); });
  }

  // contact form: designed client-side validation (server validation still applies)
  var cf = d.getElementById('GSContactForm');
  if (cf) {
    var rules = [
      { el: cf.querySelector('#GSEmail'), test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }, msg: function (v) { return v ? 'Please enter a valid email address.' : 'Please enter your email.'; } },
      { el: cf.querySelector('#GSMsg'), test: function (v) { return v.length >= 2; }, msg: function () { return 'Please tell us how we can help.'; } }
    ];
    function check(r) {
      if (!r.el) return true;
      var f = r.el.closest('.gs-field'), v = r.el.value.trim(), ok = r.test(v), m = f.querySelector('.gs-field__msg');
      f.classList.toggle('is-error', !ok); r.el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) { if (!m) { m = d.createElement('span'); m.className = 'gs-field__msg'; m.id = r.el.id + '-err'; m.setAttribute('role', 'alert'); f.appendChild(m); r.el.setAttribute('aria-describedby', m.id); } m.textContent = r.msg(v); }
      else if (m) { m.remove(); r.el.removeAttribute('aria-describedby'); }
      return ok;
    }
    rules.forEach(function (r) { if (r.el) r.el.addEventListener('blur', function () { if (r.el.value.trim() || r.el.closest('.gs-field').classList.contains('is-error')) check(r); }); });
    cf.addEventListener('submit', function (e) {
      var bad = rules.filter(function (r) { return !check(r); });
      if (bad.length) { e.preventDefault(); bad[0].el.focus(); }
    });
  }

  // V3 reels: genuine videos only. Play muted while mostly visible (one per strip), tap to pause, sound toggle, progress.
  var reels = [].slice.call(d.querySelectorAll('[data-gs-reel]'));
  if (reels.length) {
    var setState = function (card, playing) { card.classList.toggle('is-playing', playing); };
    reels.forEach(function (card) {
      var v = card.querySelector('video'); if (!v) return;
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.preload = 'none';
      var bar = card.querySelector('[data-gs-reel-bar]');
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration).toFixed(3) + ')'; });
      v.addEventListener('play', function () { setState(card, true); reels.forEach(function (o) { if (o !== card) { var ov = o.querySelector('video'); if (ov && !ov.paused && o.closest('[data-gs-reels-strip],[data-gs-reels]') === card.closest('[data-gs-reels-strip],[data-gs-reels]')) ov.pause(); } }); });
      v.addEventListener('pause', function () { setState(card, false); });
      var tog = function () { card.dataset.userPaused = v.paused ? '' : '1'; if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); };
      var tb = card.querySelector('[data-gs-reel-toggle]'); if (tb) tb.addEventListener('click', tog);
      v.addEventListener('click', tog);
      var sb = card.querySelector('[data-gs-reel-sound]');
      if (sb) sb.addEventListener('click', function () {
        v.muted = !v.muted; sb.setAttribute('aria-pressed', String(!v.muted)); sb.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off'); card.classList.toggle('has-sound', !v.muted);
        if (!v.muted && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    var saveData = navigator.connection && navigator.connection.saveData;
    if ('IntersectionObserver' in window) {
      // fetch video metadata only when a reel is about to be seen
      var pre = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var v = e.target.querySelector('video'); if (v && v.preload === 'none') v.preload = 'metadata'; pre.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
      reels.forEach(function (c) { pre.observe(c); });
    }
    if ('IntersectionObserver' in window && !reduce && !saveData) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var card = e.target, v = card.querySelector('video'); if (!v) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.75 && !card.dataset.userPaused) {
            var strip = card.closest('[data-gs-reels-strip],[data-gs-reels]');
            var other = strip && [].some.call(strip.querySelectorAll('video'), function (o) { return o !== v && !o.paused; });
            if (!other) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!e.isIntersecting || e.intersectionRatio < 0.3) { v.pause(); }
        });
      }, { threshold: [0, 0.3, 0.75, 1] });
      reels.forEach(function (c) { rio.observe(c); });
    }
  }

  // Unverified social proof: shown only on unpublished preview themes or in the editor, never on the live theme.
  var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || 'main';
  if (role !== 'main' || (window.Shopify && Shopify.designMode)) {
    d.querySelectorAll('template[data-gs-preview-only]').forEach(function (t) { t.parentNode.insertBefore(t.content.cloneNode(true), t); });
  }

  // V3 depth: [data-gs-depth] layers drift on scroll and (fine pointers) follow the cursor slightly; uses the
  // independent `translate` property so authored rotations are preserved.
  var depth = [].slice.call(d.querySelectorAll('[data-gs-depth]'));
  if (depth.length && richMotion) {
    var mx = 0, my = 0;
    var paint = function () {
      var vh = window.innerHeight;
      depth.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-gs-depth')) || 0.05, r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var sy = Math.max(-40, Math.min(40, (r.top + r.height / 2 - vh / 2) * -k));
        el.style.translate = (mx * k * 160).toFixed(1) + 'px ' + (sy + my * k * 160).toFixed(1) + 'px';
      });
    };
    window.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    if (window.matchMedia('(pointer: fine)').matches) {
      window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; requestAnimationFrame(paint); }, { passive: true });
    }
    paint();
  }

  // Header overlap: on templates where the header overlays the first section, expose its height as --gs-hh.
  var hero3 = d.querySelector('.gs-hero3');
  if (hero3) {
    var setHH = function () {
      var hdr = d.querySelector('.section-header, header-group, .shopify-section-group-header-group');
      var hb = hdr ? hdr.getBoundingClientRect().bottom + window.scrollY : 0;
      var top = hero3.getBoundingClientRect().top + window.scrollY;
      d.documentElement.style.setProperty('--gs-hh', Math.max(0, Math.round(hb - top)) + 'px');
    };
    setHH(); window.addEventListener('resize', setHH);
  }

  // V3 information pages: build an "On this page" index from headings (or bold lead lines) and track the active one.
  // Presentation only: hide decorative publication-date labels ("Effective July 23, 2025", "Last updated: ...").
  // The stored policy text is unchanged.
  var DATE = '(january|february|march|april|may|june|july|august|september|october|november|december)\\s+\\d{1,2},?\\s+\\d{4}';
  var reSuffix = new RegExp('\\s*[-\u2013\u2014|:]\\s*(effective|last updated|updated)( date)?\\s*:?\\s*' + DATE + '\\.?\\s*$', 'i');
  var reLine = new RegExp('^\\s*(effective|last updated|updated|effective date|date of last update)( date)?\\s*(on)?\\s*:?\\s*' + DATE + '\\.?\\s*$', 'i');
  d.querySelectorAll('[data-gs-info-content]').forEach(function (c) {
    c.querySelectorAll('h1, h2, h3, h4, p, li, div, span').forEach(function (el) {
      if (el.children.length > 3) return;
      var t = el.textContent;
      if (reLine.test(t)) { el.hidden = true; el.setAttribute('data-gs-date-label', ''); return; }
      if (/^H[1-4]$/.test(el.tagName) && reSuffix.test(t)) {
        var walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, last = null;
        while ((n = walker.nextNode())) { if (n.nodeValue.trim()) last = n; }
        if (last && reSuffix.test(last.nodeValue)) last.nodeValue = last.nodeValue.replace(reSuffix, '');
      }
    });
  });
  d.querySelectorAll('[data-gs-info]').forEach(function (wrap) {
    var content = wrap.querySelector('[data-gs-info-content]'), toc = wrap.querySelector('[data-gs-toc]');
    if (!content || !toc) return;
    var heads = [].slice.call(content.querySelectorAll('h2, h3'));
    if (heads.length < 3) {
      heads = [].slice.call(content.querySelectorAll('p')).filter(function (p) {
        var b = p.querySelector('strong, b'); var t = p.textContent.trim();
        return b && b.textContent.trim().length >= t.length - 2 && t.length > 2 && t.length < 90;
      });
    }
    if (heads.length < 3) return;
    var ol = toc.querySelector('ol'), links = [];
    heads.slice(0, 14).forEach(function (h, i) {
      if (!h.id) h.id = 'gs-sec-' + (i + 1);
      h.style.scrollMarginTop = '130px';
      var li = d.createElement('li'), a = d.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim().replace(/[:：]$/, '').slice(0, 60);
      li.appendChild(a); ol.appendChild(li); links.push([h, a]);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var tio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (pair) { pair[1].classList.toggle('is-active', pair[0] === e.target); }); });
      }, { rootMargin: '-20% 0px -70% 0px' });
      links.forEach(function (pair) { tio.observe(pair[0]); });
    }
  });

  // V4 FAQ: animated close for native <details>, live filter, category index highlighting.
  d.querySelectorAll('[data-gs-faq]').forEach(function (faq) {
    var items = [].slice.call(faq.querySelectorAll('[data-gs-faq-item]'));
    items.forEach(function (det) {
      var sum = det.querySelector('summary');
      sum.addEventListener('click', function (e) {
        if (det.open && !reduce) {
          e.preventDefault(); det.classList.add('is-closing');
          setTimeout(function () { det.open = false; det.classList.remove('is-closing'); }, 480);
        }
      });
    });
    var input = faq.querySelector('[data-gs-faq-search]'), empty = faq.querySelector('[data-gs-faq-empty]');
    if (input) input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), shown = 0;
      items.forEach(function (det) {
        var hit = !q || det.textContent.toLowerCase().indexOf(q) > -1;
        det.hidden = !hit; if (hit) shown++;
        if (q && hit && q.length > 2) det.open = true;
      });
      faq.querySelectorAll('[data-gs-faq-group]').forEach(function (g) { g.hidden = !g.querySelector('[data-gs-faq-item]:not([hidden])'); });
      if (empty) empty.hidden = shown > 0;
    });
    var navLinks = [].slice.call(faq.querySelectorAll('.gs-faq__nav a'));
    if ('IntersectionObserver' in window && navLinks.length) {
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) navLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); }); });
      }, { rootMargin: '-25% 0px -65% 0px' });
      faq.querySelectorAll('[data-gs-faq-group]').forEach(function (g) { fio.observe(g); });
    }
  });

  // V4 footer: link groups start collapsed on phones (open on larger screens).
  if (window.matchMedia('(max-width: 749px)').matches) d.querySelectorAll('.gs-foot__acc[open]').forEach(function (x) { x.open = false; });

  // V4: label policy table cells so they can stack as label/value rows on phones.
  d.querySelectorAll('[data-gs-info-content] table').forEach(function (t) {
    var rows = t.querySelectorAll('tr'); if (rows.length < 2) return;
    var heads = [].map.call(rows[0].children, function (c) { return c.textContent.trim(); });
    [].slice.call(rows, 1).forEach(function (r) { [].forEach.call(r.children, function (c, i) { if (heads[i]) c.setAttribute('data-label', heads[i]); }); });
    t.classList.add('gs-stack');
  });

  // V5: expose the mobile header height for the menu drawer offset.
  var mh = d.querySelector('.section-header');
  if (mh) { var setMh = function () { d.documentElement.style.setProperty('--gs-mhh', mh.offsetHeight + 'px'); }; setMh(); window.addEventListener('resize', setMh); }

  // V5 mobile swipe cue: progress line + counter for horizontal galleries (passive listeners, rAF-throttled).
  d.querySelectorAll('[data-gs-swipe]').forEach(function (cue) {
    var host = cue.parentElement, track = host && host.querySelector('.gs-chapters__deck, .gs-cedit__deck, .gs-gift3__track');
    if (!track) return;
    var fill = cue.querySelector('[data-gs-swipe-fill]'), count = cue.querySelector('[data-gs-swipe-count]');
    var items = function () { return [].filter.call(track.children, function (c) { return c.getClientRects().length; }); };
    var raf = 0;
    var paint = function () {
      raf = 0; var n = items().length; if (!n) return;
      var max = track.scrollWidth - track.clientWidth, p = max > 0 ? track.scrollLeft / max : 0;
      var vis = Math.min(1, track.clientWidth / track.scrollWidth);
      fill.style.width = Math.max(12, vis * 100) + '%';
      fill.style.transform = 'translateX(' + (p * (100 / Math.max(vis, .12) - 100)) + '%)';
      var idx = Math.min(n, Math.round(p * (n - 1)) + 1);
      count.textContent = (idx < 10 ? '0' : '') + idx + ' / ' + (n < 10 ? '0' : '') + n;
      cue.hidden = max <= 4;
    };
    track.addEventListener('scroll', function () { if (track.scrollLeft > 8) cue.classList.add('is-used'); if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(paint); });
    paint();
  });

})();
